module.exports = __webpack_public_path__ + "img/xieta.da588bb.png";